
import { getAuthMapping } from "./authmapping.utils";

const apiURL = process.env.REACT_APP_API_URL;
const fakeURL = process.env.REACT_APP_LOCAL_API_URL;
const apiKey = process.env.REACT_APP_API_KEY;
const loaclUrl = process.env.REACT_APP_STAGE_API_URL;

var tmpHeaders = {
  "Content-Type": "application/json",
  "Authorization": apiKey,
}

const tmpHeadersExchange = {
  "Content-Type": "application/json",
};

const myHeaders = new Headers(tmpHeaders);

export const setUpAPI = async (command, data, method = 'GET', parameters = {}, headers = myHeaders) => {
  return await new Promise(async (resolve, reject) => {
    try {
      var url = apiURL;

      var requestOptions = {};

      if (command) {
        url = `${url}${command}`;
      }

      if (parameters) {
        url += `?`;

        Object.entries(parameters).map((entry, index) => {
          const [key, value] = entry;
          url += `${key}=${value}&`
        });

        url = url.substring(0, url.length - 1);
      }

      if (method) {
        requestOptions.method = method;
      }

      if (headers) {
        requestOptions.headers = headers
      }

      if (data) {
        var raw = JSON.stringify(data);
        requestOptions.body = raw;
      }

      return fetch(url, requestOptions)
        .then((response) => resolve(response))
        .catch((err) => { throw new Error(err) });
    } catch (error) {
      console.error("Sorry we have had problems please report it to the administrator: ", error)
    }

  })
}

export const apiUrlDomain = apiURL.substring(0, apiURL.length - 5)

export const setUpAPIExchange = async (
  command,
  data,
  method = "POST",
  parameters = {},
  headers = true,
  includeCred = false
) => {
  const localStorageData = getAuthMapping();
  let url = loaclUrl;
  var requestOptions = {};

  if (command) {
    url = `${url}${command}`;
  }

  if (parameters) {
    url += `?`;

    Object.entries(parameters).map((entry, index) => {
      const [key, value] = entry;
      url += `${key}=${value}&`;
    });

    url = url.substring(0, url.length - 1);
  }

  if (method) {
    requestOptions.method = method;
  }

  if (headers) {
    requestOptions.headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${
        localStorageData && localStorageData?.accessToken
      }`,
    };
  }

  if (includeCred) {
    requestOptions.withCredentials = true;
    requestOptions.credentials = "include";
  }

  if (data) {
    var raw = JSON.stringify(data);
    requestOptions.body = raw;
  }

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      if (command === "wallet/v1/wallet/user/get_user_balance/fiat") {
        const currentErrorData = JSON.parse(localStorage.getItem('apiError')) || { error: '', count: 0 };

        let newCount = currentErrorData.count + 1;
        if (newCount > 2 && newCount !== 4) {
          newCount = 4;
        }

        localStorage.setItem('apiError', JSON.stringify({
          error: `HTTP error! status: ${response.status}`,
          count: newCount
        }));
        localStorage.setItem('apiError2', JSON.stringify({
          error: `HTTP error! status: ${response.status}`,
          count: newCount
        }));
      } else {
        localStorage.setItem('apiError', JSON.stringify({
          error: `HTTP error! status: ${response.status}`,
          count: 4
        }));
      }

      localStorage.setItem('apiErrorMessage', `HTTP error! status: ${response.statusText} type ${response.type}`);
      localStorage.setItem('apiErrorURL', `HTTP error! status: ${response.url}`);

      console.log(`HTTP error! status: ${response.status}`);
      console.log(`HTTP error! status: ${response.statusText} type ${response.type}`);
      console.log(`HTTP error! status: ${response.url}`);

      if (response.status === 401) {
        document.cookie.split(';').forEach(cookie => {
          const [name] = cookie.split('=');
          document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;`;
        });

        if (window.location.href.indexOf("/logout") === -1) {
          window.location.href = '/logout';
        }
      } else {
        return response;
      }
    }

    localStorage.removeItem('apiError');
    //localStorage.removeItem('apiErrorMessage');
    //localStorage.removeItem('apiErrorURL');
    return response;
  } catch (error) {
    console.error("Error in the API request:", error);

    if (command === "wallet/v1/wallet/user/get_user_balance/fiat") {
      const currentErrorData = JSON.parse(localStorage.getItem('apiError')) || { error: '', count: 0 };

      let newCount = currentErrorData.count + 1;
      if (newCount > 2 && newCount !== 4) {
        newCount = 4;
      }

      localStorage.setItem('apiError', JSON.stringify({
        error: 'Connection problems',
        count: newCount
      }));
    } else {
      localStorage.setItem('apiError', JSON.stringify({
        error: 'Connection problems',
        count: 4
      }));
    }

    return error;
  }
};



